import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenericCrudService extends CrudService<any> {
  constructor(http: HttpClient, private snackBar: MatSnackBar) {
    super('', http);
  }

  snackSuccess(): void {
    this.snackBar.open('Registro salvo com sucesso', 'Fechar', {
      duration: 2000,
      panelClass: ['mat-accent'],
    });
  }

  snackMessage(msg: any): void {
    this.snackBar.open(msg, 'Fechar', {
      duration: 2000,
      panelClass: ['mat-accent'],
    });
  }

  snackError(message: any): void {
    this.snackBar.open(message, 'Fechar', {
      duration: 2000,
      panelClass: ['mat-warn'],
    });
  }

  requestPutUrl(url: string): Observable<any> {
    return this.http.put<any>(environment.apiUrl + url, null);
  }

  updateUrl(item: any, url: string): Observable<any> {
    return this.http.put<any>(environment.apiUrl + url, item);
  }

  createUrl(item: any, url: string): Observable<any> {
    return this.http.post<any>(environment.apiUrl + url, item);
  }

  getUrl(id: string, url: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + url + '/' + this.generatePathVariable(id));
  }

  getAllUrl(url: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + url);
  }

  protected generatePathVariable(id: string): string {
    return id;
  }
}
